import { render, staticRenderFns } from "./LuExciseProjectionType.vue?vue&type=template&id=beabbba4&"
import script from "./LuExciseProjectionType.vue?vue&type=script&lang=js&"
export * from "./LuExciseProjectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports